import { Grid, Box, Typography } from "@mui/material";


const StatItem = ({label, icon, value, postfix}) => {
    return (
      <>
      <Grid item xs={12} md={7}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
          {icon}
          <Typography variant="body1">
              {label}
          </Typography>
        </Box> 
      </Grid>
      <Grid item xs={12} md={5}>
        <strong>{value}</strong>&nbsp;{postfix}
      </Grid>
      </>
    )
  }

  export default StatItem;